module.exports = __webpack_public_path__ + "img/sCandyXmas_350x350.1b30c2b8.jpg";